// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Sidebar-style___drawer--x9Cch {
  width: 200px;
  display: flex;
  flex-direction: column;
  border-radius: 0;
}

  @media only screen and (min-width: 1024px) {.components-Sidebar-style___drawer--x9Cch {
    width: 240px
}
  }

.components-Sidebar-style___drawer--x9Cch > div {
  width: 200px;
  background: #1b2432;
  color: #fff;
  border-radius: 0;
}

@media only screen and (min-width: 1024px) {

.components-Sidebar-style___drawer--x9Cch > div {
    width: 240px
}
  }

.components-Sidebar-style___logo--TKjeT {
  font-size: 17px;
  font-weight: 700;
  text-align: left;
  padding: 24px 24px 12px;
}

.components-Sidebar-style___bottomNav--ZgNew {
  padding: 12px 0;
  text-align: left;
}

.components-Sidebar-style___bottomNav--ZgNew > div {
    cursor: pointer;
    font-size: 15px;
    padding: 13px 24px;
    line-height: 1.15rem;
  }

.components-Sidebar-style___bottomNav--ZgNew > div:hover {
      background-color: rgba(95, 102, 112, 0.4);
    }

.components-Sidebar-style___bottomNav--ZgNew .components-Sidebar-style___active--aDRF1 {
    background-color: rgba(95, 102, 112, 0.4) !important;
  }

.components-Sidebar-style___bottomNav--ZgNew .components-Sidebar-style___inactive--FXSRJ {
    background-color: #1b2432;
  }
`, "",{"version":3,"sources":["webpack://./components/Sidebar/style.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAKlB;;EAHE,4CANF;IAOI;AAEJ;EADE;;AAGF;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAKlB;;AAHE;;AANF;IAOI;AAEJ;EADE;;AAGF;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAoBlB;;AAlBE;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oBAAoB;EAKtB;;AAHE;MACE,yCAAyC;IAC3C;;AAGF;IACE,oDAAoD;EACtD;;AAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".drawer {\n  width: 200px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0;\n\n  @media only screen and (min-width: 1024px) {\n    width: 240px;\n  }\n}\n\n.drawer > div {\n  width: 200px;\n  background: #1b2432;\n  color: #fff;\n  border-radius: 0;\n\n  @media only screen and (min-width: 1024px) {\n    width: 240px;\n  }\n}\n\n.logo {\n  font-size: 17px;\n  font-weight: 700;\n  text-align: left;\n  padding: 24px 24px 12px;\n}\n\n.bottomNav {\n  padding: 12px 0;\n  text-align: left;\n\n  > div {\n    cursor: pointer;\n    font-size: 15px;\n    padding: 13px 24px;\n    line-height: 1.15rem;\n\n    &:hover {\n      background-color: rgba(95, 102, 112, 0.4);\n    }\n  }\n\n  .active {\n    background-color: rgba(95, 102, 112, 0.4) !important;\n  }\n\n  .inactive {\n    background-color: #1b2432;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawer": `components-Sidebar-style___drawer--x9Cch`,
	"logo": `components-Sidebar-style___logo--TKjeT`,
	"bottomNav": `components-Sidebar-style___bottomNav--ZgNew`,
	"active": `components-Sidebar-style___active--aDRF1`,
	"inactive": `components-Sidebar-style___inactive--FXSRJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
